import { find } from 'lodash';
import { statsConstants } from '../constants/stats';
import { statsService } from '../services/stats';
import { statsFormatter } from '../formatters/stats';

export const statsActions = {
    getTopStats,
    getCatalogStats,
    getAllVendorStats,
    getVendorStats,
    getAllTopTerritoryStats,
    getVendorTimeseries,
    getTopTerritoryStats,
    getTopTerritoryTimeseries,
    getAllTerritoryStats,
    getTerritoryStats,
    getTerritoryTimeseries,    
    getDemographicsStats,
    getDemographicsTimeseries,
    getDevicesStats,
    getSourcesStats,
    getSourcesTimeseries,
    getTransactions,
    getTransactionsTimeseries,
    getStatementTotals,
    forceLoadAllTerritoriesData,
    forceLoadAllTopTerritoriesData,
    forceLoadAllVendorsData,
    compareEntitiesIncome
};

function getTopStats(useCache) {
    return ( dispatch, getState ) => {
        dispatch(request());
        const globalFilter = getState().filter.global;
        statsService.getTopStats(globalFilter)
            .then(
                stats => {
                    const data = statsFormatter.formatTop(stats);
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_TOP_STATS_REQUEST } }
    function success(stats) { return { type: statsConstants.GET_TOP_STATS_SUCCESS, stats } }
    function failure(error) { return { type: statsConstants.GET_TOP_STATS_FAILURE, error } }
}

function getCatalogStats(useCache) {
    return (dispatch, getState) => {
        dispatch(request());
        
        const stats = useCache ? getState().stats.catalog : undefined;
        if(stats!==undefined) {
            dispatch(success(stats));
            return;
        }
        const globalFilter = getState().filter.global;
        statsService.getCatalogStats(globalFilter)
            .then(
                stats => {
                    const data = statsFormatter.formatCatalogStats(stats);
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_CATALOG_STATS_REQUEST } }
    function success(stats) { return { type: statsConstants.GET_CATALOG_STATS_SUCCESS, stats } }
    function failure(error) { return { type: statsConstants.GET_CATALOG_STATS_FAILURE, error } }
}

function getDefaultVendorOptions(sort, page, parentEntity, parentEntityID, limit, parentEntityTitle, dateStart, dateEnd) {
    let options = {
        sorted: sort, 
        page,
        filtered: [{
            id: 'limit',
            value: limit
        }]
    };
    if(parentEntity && parentEntityID) {
        options.filtered.push({
            id: parentEntity,
            value: parentEntityID
        });
    }
    if(parentEntityTitle) {
        options.filtered.push({
            id: 'parentEntityTitle',
            value: parentEntityTitle
        });
    }
    if(dateStart) {
        options.filtered.push({
            id: 'date_start',
            value: dateStart
        });
    }
    if(dateEnd) {
        options.filtered.push({
            id: 'date_end',
            value: dateEnd
        });
    }

    return options;    
}

function getVendorStats({mode, sort, vendor, contentType, limit, page}, useCache, parentEntity, parentEntityID = 0, dateStart, dateEnd) {
    return ( dispatch, getState ) => {
        dispatch(request(parentEntityID));
        let options = getDefaultVendorOptions(sort, page, parentEntity, parentEntityID, limit, dateStart, dateEnd);
        let globalFilter = getState().filter.global,
            cache = useCache ? get(getState(), `stats.vendors.${parentEntityID}.cache`) : null, 
            getData = cache ? Promise.resolve(cache) : statsService.getVendorStats(options, globalFilter); 
            return getData.then(
                stats => {
                    let totals = stats.result.length > 0 ? find(stats.result, entity=>entity.customer == '') : {},
                            data = stats.result.filter(entity=>entity.customer != '');
                    data = statsFormatter.formatVendor(data, mode, vendor, contentType, totals);
                    totals = statsFormatter.formatVendorTotals(totals);
                    
                    dispatch(success(parentEntityID, data, totals, stats));
                    return data;
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request(id) { return { type: statsConstants.GET_VENDOR_STATS_REQUEST, id } }
    function success(id, stats, totals, cache) { return { type: statsConstants.GET_VENDOR_STATS_SUCCESS, id, stats, totals, cache } }
    function failure(error) { return { type: statsConstants.GET_VENDOR_STATS_FAILURE, error } }
}

function getAllVendorStats({mode, sort, vendor, contentType, limit, page, parentEntityTitle}, useCache, parentEntity, parentEntityID = 0, dateStart, dateEnd) {
    return ( dispatch, getState ) => {
        dispatch(request(parentEntityID));
        let options = getDefaultVendorOptions(sort, page, parentEntity, parentEntityID, limit, parentEntityTitle, dateStart, dateEnd);        
        let globalFilter = getState().filter.global;
            
        return statsService.getAllVendorStats(options, globalFilter).then(
            stats => {
                dispatch(success(parentEntityID, stats));
                return stats;
            },
            error => {
                dispatch(failure('error'))
            }
        );
    };

    function request(id) { return { type: statsConstants.GET_ALL_VENDOR_STATS_REQUEST, id } }
    function success(id, stats) { return { type: statsConstants.GET_ALL_VENDOR_STATS_SUCCESS, id, stats } }
    function failure(id, error) { return { type: statsConstants.GET_ALL_VENDOR_STATS_FAILURE, id, error } }
}

function getVendorTimeseries({mode, sort, vendor, contentType, limit, page, ids}, useCache, parentEntity, parentEntityID = 0, dateStart, dateEnd) {
    return ( dispatch, getState ) => {
        dispatch(request(parentEntityID));
        let options = {sorted: sort, page, ids};
        if(parentEntity && parentEntityID) {
            options.filtered = [{
                id: parentEntity,
                value: parentEntityID
            },
            {
                id: 'limit',
                value: limit
            }]
        }
        else {
            options.filtered = [{
                id: 'limit',
                value: limit
            }]
        };
        
        if(dateStart) {
            options.filtered.push({
                id: 'date_start',
                value: dateStart
            });
        }
        if(dateEnd) {
            options.filtered.push({
                id: 'date_end',
                value: dateEnd
            });
        }

        let globalFilter = getState().filter.global,
            cache = false, // useCache ? getState().stats.topTerritoryCache : null, 
            getData = cache ? Promise.resolve(cache) : statsService.getVendorTimeseries(options, globalFilter);
            return getData
            .then(
                stats => {
                    const data = statsFormatter.formatVendorTimeseries(stats.result);
                    dispatch(success(parentEntityID, data, stats));
                    return stats;
                },
                error => {
                    dispatch(failure(parentEntityID, 'error'))
                }
            );
    };

    function request(id) { return { type: statsConstants.GET_VENDOR_TIMESERIES_REQUEST, id } }
    function success(id, timeseries, cache) { return { type: statsConstants.GET_VENDOR_TIMESERIES_SUCCESS, id, timeseries, cache } }
    function failure(id, error) { return { type: statsConstants.GET_VENDOR_TIMESERIES_FAILURE, id, error } }
}

function getTopTerritoryStats({mode, sort, limit, page}, useCache) {
    return ( dispatch, getState ) => {
        dispatch(request());
        let globalFilter = getState().filter.global,
            cache = useCache ? getState().stats.topTerritoryCache : null, 
            getData = cache ? Promise.resolve(cache) : statsService.getTopTerritoryStats({sorted: sort, limit, page}, globalFilter);
            return getData
            .then(
                stats => {
                    let totals = stats.result.length > 0 ? find(stats.result, entity=>entity.country_code == '') : {},
                            data = stats.result.filter(entity=>entity.country_code != '');
                    
                    data = statsFormatter.formatTopTerritory(data, totals);
                    totals = statsFormatter.formatVendorTotals(totals);
                    dispatch(success(data, totals, stats));
                    return data;
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_TOP_TERRITORY_STATS_REQUEST } }
    function success(stats, totals, cache) { return { type: statsConstants.GET_TOP_TERRITORY_STATS_SUCCESS, stats, totals, cache } }
    function failure(error) { return { type: statsConstants.GET_TOP_TERRITORY_STATS_FAILURE, error } }
}

function getAllTopTerritoryStats({mode, sort, limit, page}, useCache) {
    return ( dispatch, getState ) => {
        dispatch(request());
        let globalFilter = getState().filter.global;
            return statsService.getAllTopTerritoryStats({sorted: sort, limit, page}, globalFilter)
            .then(
                stats => {
                    dispatch(success(stats));
                    return stats;
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_ALL_TOP_TERRITORY_STATS_REQUEST } }
    function success(stats) { return { type: statsConstants.GET_ALL_TOP_TERRITORY_STATS_SUCCESS, stats } }
    function failure(error) { return { type: statsConstants.GET_ALL_TOP_TERRITORY_STATS_FAILURE, error } }
}


function getTopTerritoryTimeseries({mode, sort, limit, page, ids}, useCache) {
    return ( dispatch, getState ) => {
        dispatch(request());
        let globalFilter = getState().filter.global,
            cache = false, // useCache ? getState().stats.topTerritoryCache : null, 
            getData = cache ? Promise.resolve(cache) : statsService.getTopTerritoryTimeseries({ids, sorted: sort, limit, page}, globalFilter);
            return getData
            .then(
                stats => {
                    const data = statsFormatter.formatTopTerritoryTimeseries(stats.result);
                    dispatch(success(data, stats));
                    return stats;
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_TOP_TERRITORY_TIMESERIES_REQUEST } }
    function success(timeseries, cache) { return { type: statsConstants.GET_TOP_TERRITORY_TIMESERIES_SUCCESS, timeseries, cache } }
    function failure(error) { return { type: statsConstants.GET_TOP_TERRITORY_TIMESERIES_FAILURE, error } }
}


function getTerritoryStats(entity, id, sorted, limit, page, continent, date_start, date_end, countries, imprint, vendor, transactionType = []) {
    return ( dispatch, getState ) => {
        dispatch(request(id));
        let globalFilter = getState().filter.global;
        const params = {filtered: {[entity]:id, continent, date_start, date_end, country_codes: countries, imprint_ids: imprint, customers: vendor, transaction_types: transactionType.map(t=>t.replace(/\,/g, '%2C'))}, sorted, limit, page};
        const dataCall = entity == 'playlists' ? statsService.getTerritoryInPlaylistStats : statsService.getTerritoryStats;
        return dataCall(params, globalFilter) 
            .then(
                stats => {
                    let totals = stats.result.length > 0 ? find(stats.result, entity=>entity.country_code == '') : {},
                            data = stats.result.filter(entity=>entity.country_code != '');              
                    data = statsFormatter.formatTopTerritory(data, totals);
                    totals = statsFormatter.formatVendorTotals(totals);
                    dispatch(success(id, data, totals));
                    return data;
                },
                error => {
                    dispatch(failure(id, 'error'))
                }
            );
    };

    function request(id) { return { type: statsConstants.GET_TERRITORY_STATS_REQUEST, id } }
    function success(id, stats, totals, cache) { return { type: statsConstants.GET_TERRITORY_STATS_SUCCESS, id, stats, totals, cache } }
    function failure(id, error) { return { type: statsConstants.GET_TERRITORY_STATS_FAILURE, id,  error } }
}


function getAllTerritoryStats(entity, id, sorted, limit, page, continent, date_start, date_end, countries, imprint, vendor, transactionType = [], parentEntityTitle) {
    return ( dispatch, getState ) => {
        dispatch(request());
        let globalFilter = getState().filter.global;
        const params = {filtered: {[entity]:id, continent, date_start, date_end, country_codes: countries, imprint_ids: imprint, customers: vendor, transaction_types: transactionType.map(t=>t.replace(/\,/g, '%2C')), parentEntityTitle}, sorted, limit, page};
        return statsService.getAllTerritoryStats(params, globalFilter)
            .then(
                stats => {
                    dispatch(success(stats));
                    return stats;
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_ALL_TERRITORY_STATS_REQUEST } }
    function success(stats) { return { type: statsConstants.GET_ALL_TERRITORY_STATS_SUCCESS, stats } }
    function failure(error) { return { type: statsConstants.GET_ALL_TERRITORY_STATS_FAILURE, error } }
}


function getTerritoryTimeseries(entity, id, ids, sorted, limit, page, continent, date_start, date_end, countries, imprint, vendor, transactionType = []) {
    return ( dispatch, getState ) => {
        dispatch(request(id));
        let globalFilter = getState().filter.global;
        const params = {filtered: {[entity]:id, continent, date_start, date_end, country_codes: countries, imprint_ids: imprint, customers: vendor, transaction_types: transactionType.map(t=>t.replace(/\,/g, '%2C'))}, ids, sorted, limit, page};
        const dataCall = entity == 'playlists' ? statsService.getTerritoryInPlaylistTimeseries : statsService.getTerritoryTimeseries;
        return dataCall(params, globalFilter) 
            .then(
                stats => {
                    const data = statsFormatter.formatTopTerritoryTimeseries(stats.result);
                    dispatch(success(id, data));
                },
                error => {
                    dispatch(failure(id, 'error'))
                }
            );
    };

    function request(id, ) { return { type: statsConstants.GET_TERRITORY_TIMESERIES_REQUEST, id } }
    function success(id, stats, cache) { return { type: statsConstants.GET_TERRITORY_TIMESERIES_SUCCESS, id, stats, cache } }
    function failure(id, error) { return { type: statsConstants.GET_TERRITORY_TIMESERIES_FAILURE, id, error } }
}



function getDemographicsStats(entity, id, useCache) {
    return ( dispatch, getState ) => {
        dispatch(request());
        let globalFilter = getState().filter.global;
        return statsService.getDemographicsStats({[entity]:id}, globalFilter) 
            .then(
                stats => {
                    const data = statsFormatter.formatDemographics(stats);
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_DEMOGRAPHICS_STATS_REQUEST } }
    function success(stats, cache) { return { type: statsConstants.GET_DEMOGRAPHICS_STATS_SUCCESS, stats, cache } }
    function failure(error) { return { type: statsConstants.GET_DEMOGRAPHICS_STATS_FAILURE, error } }
}

function getDemographicsTimeseries(entity, id, useCache) {
    return ( dispatch, getState ) => {
        dispatch(request());
        let globalFilter = getState().filter.global;
        return statsService.getDemographicsTimeseries({[entity]:id}, globalFilter) 
            .then(
                stats => {
                    const data = statsFormatter.formatDemographicsTimeseries(stats);
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_DEMOGRAPHICS_TIMESERIES_REQUEST } }
    function success(stats, cache) { return { type: statsConstants.GET_DEMOGRAPHICS_TIMESERIES_SUCCESS, stats, cache } }
    function failure(error) { return { type: statsConstants.GET_DEMOGRAPHICS_TIMESERIES_FAILURE, error } }
}


function getDevicesStats(entity, id, useCache) {
    return ( dispatch, getState ) => {
        dispatch(request());
        let globalFilter = getState().filter.global;
        return statsService.getDevicesStats({[entity]:id}, globalFilter) 
            .then(
                stats => {
                    const data = statsFormatter.formatDevices(stats);
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_DEVICES_STATS_REQUEST } }
    function success(stats, cache) { return { type: statsConstants.GET_DEVICES_STATS_SUCCESS, stats, cache } }
    function failure(error) { return { type: statsConstants.GET_DEVICES_STATS_FAILURE, error } }
}

function getSourcesStats(entity, id, useCache) {
    return ( dispatch, getState ) => {
        dispatch(request());
        let globalFilter = getState().filter.global;
        return statsService.getSourcesStats({[entity]:id}, globalFilter) 
            .then(
                stats => {
                    const data = statsFormatter.formatSources(stats);
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_SOURCES_STATS_REQUEST } }
    function success(stats, cache) { return { type: statsConstants.GET_SOURCES_STATS_SUCCESS, stats, cache } }
    function failure(error) { return { type: statsConstants.GET_SOURCES_STATS_FAILURE, error } }
}

function getSourcesTimeseries(entity, id, useCache = false) {
    return ( dispatch, getState ) => {
        dispatch(request());
        let globalFilter = getState().filter.global;
        
        const cache = useCache ? getState().stats.sourcesTimeseries : null, 
        getData = cache ? Promise.resolve(cache) : statsService.getSourcesTimeseries({[entity]:id}, globalFilter);

        
        return  getData
            .then(
                stats => {
                    const data = statsFormatter.formatSourcesTimeseries(stats);
                    dispatch(success(data));
                    return data;
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_SOURCES_TIMESERIES_REQUEST } }
    function success(stats, cache) { return { type: statsConstants.GET_SOURCES_TIMESERIES_SUCCESS, stats, cache } }
    function failure(error) { return { type: statsConstants.GET_SOURCES_TIMESERIES_FAILURE, error } }
}

function getTransactions(entity, id) {
    return ( dispatch, getState ) => {
        dispatch(request(id));
        const globalFilter = getState().filter.global;
        statsService.getTransactions(entity, id, globalFilter)
            .then(
                stats => {
                    const data = statsFormatter.formatTransactions(stats.result);
                    dispatch(success(id, data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request(id) { return { type: statsConstants.GET_TRANSACTIONS_REQUEST, id } }
    function success(id, data) { return { type: statsConstants.GET_TRANSACTIONS_SUCCESS, id, data} }
    function failure(error) { return { type: statsConstants.GET_TRANSACTIONS_FAILURE, error } }
}

function getTransactionsTimeseries(entity, id) {
    return ( dispatch, getState ) => {
        dispatch(request());
        const globalFilter = getState().filter.global;
        statsService.getTransactionsTimeseries(entity, id, globalFilter)
            .then(
                stats => {
                    const data = statsFormatter.formatTransactionsTimeseries(stats.result);
                    dispatch(success(id, data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_TRANSACTIONS_TIMESERIES_REQUEST } }
    function success(id, data) { return { type: statsConstants.GET_TRANSACTIONS_TIMESERIES_SUCCESS, id, data} }
    function failure(error) { return { type: statsConstants.GET_TRANSACTIONS_TIMESERIES_FAILURE, error } }
}


function getStatementTotals() {
    return ( dispatch, getState ) => {
        dispatch(request());
        const globalFilter = getState().filter.global;
        statsService.getStatementTotals(globalFilter)
            .then(
                stats => {
                    const data = statsFormatter.formatStatementTotals(stats.result);
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.GET_STATEMENT_TOTALS_REQUEST } }
    function success(data) { return { type: statsConstants.GET_STATEMENT_TOTALS_SUCCESS, data} }
    function failure(error) { return { type: statsConstants.GET_STATEMENT_TOTALS_FAILURE, error } }
}


function forceLoadAllData(force, key) {
    return dispatch => {
        dispatch(set(force));
    };

    function set(force) { return { type: statsConstants[key], force} }
}

function forceLoadAllTerritoriesData(force) {
    return forceLoadAllData(force, 'FORCE_LOAD_ALL_TERRITORIES_DATA');
}
function forceLoadAllTopTerritoriesData(force) {
    return forceLoadAllData(force, 'FORCE_LOAD_ALL_TOP_TERRITORIES_DATA');
}
function forceLoadAllVendorsData(force) {
    return forceLoadAllData(force, 'FORCE_LOAD_ALL_VENDORS_DATA');
}



function compareEntitiesIncome(entities) {
    return ( dispatch, getState ) => {
        dispatch(request());
        const globalFilter = getState().filter.global;
        statsService.compareEntitiesIncome(entities, globalFilter)
            .then(
                stats => {
                    const data = statsFormatter.formatEntitiesIncome(stats.result, entities);
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure('error'))
                }
            );
    };

    function request() { return { type: statsConstants.COMPARE_ENTITIES_INCOME_REQUEST } }
    function success(data) { return { type: statsConstants.COMPARE_ENTITIES_INCOME_SUCCESS, data} }
    function failure(error) { return { type: statsConstants.COMPARE_ENTITIES_INCOME_FAILURE, error } }
}